import { assets } from "@/lib/assets";

export const SERVICES = [
  {
    slug: "tax-planning-compliance",
    title: "Tax Planning & Compliance",
    icon: assets.services.tax,
    short:
      "Comply with the tax authorities with confidence — timely, accurate filings that protect you and minimize liabilities.",
    body:
      "Every individual and business owners need to comply with the tax authorities and AGE-T is here to support, to help and to protect you from inaccurate or late filings. With extensive knowledge of tax compliance regulations AGE-T offer a range of services tailored made to help you and your business report to tax authorities in a timely and accurate way, while minimizing tax liabilities on your family, your business or your company profits.",
  },
  {
    slug: "compilation-of-financial-statements",
    title: "Compilation of Financial Statements",
    icon: assets.services.compilation,
    short:
      "Clear, concise statements that represent your business to lenders and partners — and help you run it more effectively.",
    body:
      "Your financial statements are an important tool for management decision but also represent your business to lenders, partners and other interested parties. AGE-T capability of financial statements compilation is a core part of the services. Each process is tailor made to the unique needs of your business. AGE-T deliver financial statements and reports that are clear, concise and acceptable to all outside parties and that can provide information and insight to help you run your business more effectively. AGE-T will work closely with you and your key employees to develop and execute a plan to complete this work by minimizing employee time spent on the process and without disrupting operations.",
  },
  {
    slug: "part-time-cfo",
    title: "Part-Time CFO",
    icon: assets.services.cfo,
    short:
      "Senior financial leadership without the full-time salary — a part-time CFO to steer growth decisions.",
    body:
      "Every growing business eventually reaches a critical point where they have to consider bringing on a chief financial officer. But if your business cannot afford the salary that accompanies the title AGE-T can be your solution with a part-time CFO.",
  },
  {
    slug: "cash-flow-management",
    title: "Cash Flow Management",
    icon: assets.services.cashflow,
    short:
      "Analyze and manage the inflow and outflow of cash to keep your business consistently positive.",
    body:
      "Achieving a positive cash flow does not come by chance. You have to work at it. You need to analyze and manage your cash flow to more effectively control the inflow and outflow of cash. Contact AGE-T to assist you with this.",
  },
  {
    slug: "new-business-formation",
    title: "New Business Formation",
    icon: assets.services.newbusiness,
    short:
      "Launch on a secure foundation — cash flow budgets, accounting software selection and the key details that matter.",
    body:
      "As entrepreneur bringing your idea to the market you will have to be well prepared and well organized at the start. AGE-T can help you preparing cash flow budget, selecting accounting software and providing other small but key details to ensure that your business gets off the ground with a secure foundation.",
  },
  {
    slug: "bank-financing",
    title: "Bank Financing",
    icon: assets.services.bank,
    short:
      "Approach lenders fully prepared with the documentation that turns loan applications into approvals.",
    body:
      "A big mistake many small business owners make in attempting to grow their business is applying for a loan with insufficient preparation. AGE-T can help you with the documentation needed for these applications such as a business plan, business credit report, income tax returns and financial statements.",
  },
];

export const EXPERIENCE = [
  {
    range: "2005 – 2020",
    company: "Aruba Ports Authority",
    role: "Financial Manager / Acting Director",
    logo: assets.company.apa,
    description:
      "Handled all activities of the finance department of the organization. Organized and managed the audit of the annual accounts by the external auditors in an efficient manner. Furthermore, financial information and advice was provided to the Director. In this position, efficient and responsible management of resources was key. As Acting Director, progress and compliance with established policy within the organization was ensured.",
  },
  {
    range: "1999 – 2005",
    company: "KPMG Aruba",
    role: "Acting Manager",
    logo: assets.company.kpmg,
    description:
      "Responsible for managing the various compilations, reviews, and audit assignments in financial reporting. It also included maintaining the network within the customer environment and guiding colleagues with their professional skills development, as well as taking care of other financial statements, such as budget, projections, and related opinions.",
  },
  {
    range: "1992 – 1999",
    company: "Ernst & Young Aruba",
    role: "Senior Assistant Accountant",
    logo: assets.company.ey,
    description:
      "In a team environment, responsible for setting up, conducting, and checking the financial administration of various external customers.",
  },
];

export const TRAININGS = [
  {
    year: "2005",
    title: "Seaport Security Professional Domain Awareness",
    org: "SEASECURE",
    items: [
      "Introduction to Maritime Security & Antiterrorism",
      "Security Measures & Vulnerability",
      "Security Equipment",
      "Threat Identification & Response",
      "Ship & Port Facility Security Actions",
      "Drills, Exercises & Search Procedures",
      "Security Administration & Management",
    ],
  },
  {
    year: "2005",
    title: "Ship Operations",
    org: "Enercon Group",
    items: [],
  },
  {
    year: "2008 – 2016",
    title: "Financial and corporate training",
    org: "",
    items: [
      "Corporate Governance Seminar (Ernst & Young)",
      "Payroll Pro Ultra Transition Course (VCC)",
      "Payroll Pro Basic (AS Aruba)",
      "International Public Sector Accounting Standards & IFRS (University of Aruba and University of Amsterdam)",
    ],
  },
  {
    year: "2015 – 2017",
    title: "In-depth course in Asset Management",
    org: "Willis Towers Watson Academy",
    items: [
      "Investment Beliefs",
      "Prudent Person and Monitoring",
      "Selection, Evaluation and Costs of Asset Management",
      "Investment Plan Design",
      "Solvency Requirements and Resilience",
      "Investment Categories and Sources of Performance",
      "Risk Budgeting and Portfolio Construction",
      "ALM and Strategic Policy",
      "Mission, Governance and Investment Beliefs",
    ],
  },
  {
    year: "2013 – 2017",
    title: "Other asset management and pension training",
    org: "",
    items: [
      "Advanced Asset Management modules (parts 1 & 2)",
      "Capacity for Change within the Pension Sector (Capas)",
      "Capital Market Review (LCG Associates, multiple sessions)",
      "The Sustainability of Our Pension System (Capas)",
      "Risk Management in Uncertain Times (Montae Caribbean)",
      "Managing a Pension Fund (Stichting Pensioen Opleidingen)",
    ],
  },
];

export const STATS = [
  { value: 13, label: "Trainings Completed" },
  { value: 9, label: "Courses Completed" },
  { value: 16, label: "Seminars Completed" },
  { value: 19, label: "Workshops Completed" },
];
